import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  Grid,
  Tooltip,
  Table,
  TableRow,
  TableCell,
  Button,
  Divider,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
import { useAwaitDialog } from "app/components/status_dialog";

function BillBackPromotionsPage() {
  const pageTitle = "Bill Back Promotions";
  usePageTitle(pageTitle);
  const navigate = useNavigate();

  const statusDialog = useAwaitDialog();
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  const [promotions, setPromotions] = useState([]);
  const [promotionTitle, setPromotionTitle] = useState(null);
  const [promotionDiscount, setPromotionDiscount] = useState(null);
  const [openCreateDialog, setOpenCreateDialog] = useState(false);

  const tableColumns = [
    { Header: "Name", accessor: "title", align: "left" },
    { Header: "Discount (%)", accessor: "discount", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        title: row.title,
        discount: `${(row.discount * 100).toFixed(2)}%`,
        actions: (
          <MDBox mt={1} variant="button">
            <Tooltip title="Manage">
              <MDButton
                size="small"
                variant="outlined"
                color="dark"
                iconOnly
                onClick={() => {
                  navigate(`/trade-marketing/promotions/bill-back/${row.reference}`);
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small">
                  settings
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Delete?`) === true) {
                  // deleteProduct(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
        // created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/tm/promotions/bill_back.json`)
        .then((result) => {
          // console.log(result.data.data.campaign.activation);
          setShowLoading(false);
          if (result.data.status === "success") {
            const rows = buildRows(result.data.data.promotions);
            setPromotions(rows);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function createPromotion() {
    if (promotionTitle === null) {
      setSeverity("error");
      setErrMsg("Enter promotion name.");
      setOpen(true);
      return;
    }

    if (promotionDiscount === null) {
      setSeverity("error");
      setErrMsg("Enter promotion discount.");
      setOpen(true);
      return;
    }

    setOpenCreateDialog(false);
    setShowLoading(true);
    const json = {
      title: promotionTitle,
      discount: promotionDiscount,
    };

    await axios
      .post("portal/tm/promotions/bill_back/create.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          await statusDialog.show(result.data.data.message, "success", "Success!");
          // setRefreshPage(!refreshPage);
          navigate(`/trade-marketing/promotions/bill-back/${result.data.data.reference}`);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openCreateDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Create Promotion</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={1}>
              <MDInput
                name="title"
                margin="dense"
                label="Promotion Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setPromotionTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={3}>
              <MDInput
                name="title"
                margin="dense"
                label="Promotion Discount (%)"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setPromotionDiscount(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenCreateDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              createPromotion();
            }}
          >
            Create
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox mt={1} mb={5}>
        {pageLoaded && (
          <MDBox>
            <MDBox>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={1}>
                  <MDBox align="center">
                    <MDBox>
                      <MDTypography variant="h6" fontSize={48}>
                        <Icon>discount</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="bold" fontSize={16}>
                        Bill Back Promotions
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontWeight="light" fontSize={16}>
                        Setup and manage your bill-back promotions seamlessly.
                        <br />
                        Monitor registered wholesalers and retailers. Track sales and verify
                        discount claims.
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={3} mb={3}>
                      <MDButton
                        variant="contained"
                        color="dark"
                        onClick={() => {
                          setPromotionTitle(null);
                          setPromotionDiscount(null);
                          setOpenCreateDialog(true);
                        }}
                        startIcon={<Icon>add</Icon>}
                      >
                        Create Promotion
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={5}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox>
                  <MDBox p={2}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Promotions
                        </MDTypography>
                      </MDBox>
                      <MDBox>
                        <MDButton
                          variant="contained"
                          color="dark"
                          iconOnly
                          onClick={() => {
                            setPromotionTitle(null);
                            setPromotionDiscount(null);
                            setOpenCreateDialog(true);
                          }}
                        >
                          <Icon>add</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                  <MDBox p={0}>
                    <DataTable
                      table={{ columns: tableColumns, rows: promotions }}
                      isSorted
                      entriesPerPage={false}
                      showTotalEntries
                      buttons
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default BillBackPromotionsPage;
